/**
 * API helpers for uploading files used by http_multipart flow steps.
 */
import { ApiError } from "./client";
import type { MultipartFileField } from "@/types";

const API_BASE = import.meta.env.VITE_API_BASE_URL || "/api";

/** Upload a file to the backend and return its stored metadata. */
export async function uploadFile(file: File): Promise<MultipartFileField> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE}/uploads`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  if (!response.ok) {
    let message = `Upload failed with status ${response.status}`;
    try {
      const data = await response.json();
      if (typeof data?.detail === "string") {
        message = data.detail;
      }
    } catch {
      // Keep the generic message.
    }
    throw new ApiError(response.status, message);
  }

  return (await response.json()) as MultipartFileField;
}
